import React from "react";
import { Link, useParams } from "react-router-dom";

import { useNewSignupCreationFlow } from "Signups/SignupView/NewSignup";
import { useSignups } from "Signups/state";

import FnrButton from "UI/FnrButton3/FnrButton";

export default function NextTab() {
  const [state] = useSignups();
  const {
    hasFundIt,
    hasSignupPayments,
    currentSignupList: {
      fundIt: { fund },
    },
  } = state;

  const { isInCreationFlow } = useNewSignupCreationFlow();
  const fundItEnabled =
    hasFundIt && hasSignupPayments && fund !== null && fund !== undefined;

  const { signupListID, signupItemID } = useParams();

  const handleNext = () => {
    const basePath = `/signups/${signupListID}/items`;
    if (fundItEnabled) {
      return basePath + `/${signupItemID}/fund-it`;
    } else {
      return basePath + `/another`;
    }
  };

  if (!isInCreationFlow) return null;

  return (
    <Link to={() => handleNext()} style={{ marginLeft: "auto" }}>
      <FnrButton color="blue">
        Next
        <i
          className="fas fa-chevron-right"
          style={{ marginLeft: "8px", fontSize: "14px" }}
        />
      </FnrButton>
    </Link>
  );
}
